import { createSlice } from "@reduxjs/toolkit";

const productSlice = createSlice({
  name: "products",
  initialState: {
    products: [],
    trendingProducts: [],
    bestSelling: [],
    categoryProducts: [],
    filterProducts: [],
    reviews: [],
    isFetching: false,
    error: false,
  },
  reducers: {
    fetchProductsStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    fetchProductsSuccess: (state, action) => {
      state.isFetching = false;
      state.products = action.payload;
    },
    fetchProductsFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    fetchTrendingProduct:  (state, action) => {
      state.isFetching = false;
      state.trendingProducts = action.payload;
    },
    fetchBestSellingProduct:  (state, action) => {
      state.isFetching = false;
      state.bestSelling = action.payload;
    },
    fetchCategoryProduct:  (state, action) => {
      state.isFetching = false;
      state.categoryProducts = action.payload;
    },
    fetchProdReviewStart: (state, action) => {
      state.isFetching = true;
      state.error = false;
    },
    fetchProdReviewSuccess: (state, action) => {
      state.isFetching = false;
      state.reviews = action.payload;
    },
    fetchProdReviewFailure: (state, action) => {
      state.isFetching = false;
      state.error = true;
    }
  },
});

export const {
  fetchProductsStart,
  fetchProductsSuccess,
  fetchProductsFailure,
  fetchTrendingProduct,
  fetchBestSellingProduct,
  fetchCategoryProduct,
  fetchProdReviewStart,
  fetchProdReviewSuccess,
  fetchProdReviewFailure
} = productSlice.actions;

export default productSlice.reducer;
